import { LinkProps, Link as RouterLink } from "react-router";

const Link = ({ target, rel, ...props }: LinkProps) => (
  <RouterLink
    className="text-gray-700 hover:text-gray-500 underline"
    target={target}
    rel={target === "_blank" && rel == null ? "noopener noreferrer" : rel}
    {...props}
  />
);

export default Link;
